import { useEffect } from 'react';

interface Product {
  id: number;
  name: string;
  category: string;
  desc: string;
  image: string;
  detail: {
    subtitle: string;
    description: string;
  };
}

interface Props {
  product: Product;
}

const ProductSeo = ({ product }: Props) => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useEffect(() => {
    const title = `${product.name} | 전립상회 PAC KOREA 건강기능식품`;
    document.title = title;

    const description = `${product.detail.description.slice(0, 120)}... 전립상회 PAC KOREA 공식 제품. 식약처 인증·GMP 공장 생산.`;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', `${product.name}, 전립상회, PAC KOREA, ${product.category}, 건강기능식품, 프로엑티브`);
    setMeta('robots', 'index, follow');

    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:type', 'product', true);
    setMeta('og:url', `${siteUrl}/product/${product.id}`, true);
    setMeta('og:image', product.image, true);
    setMeta('og:locale', 'ko_KR', true);
    setMeta('og:site_name', '전립상회 PAC KOREA', true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('twitter:image', product.image);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/product/${product.id}`);

    let lastmod = document.querySelector('meta[name="last-modified"]') as HTMLMetaElement | null;
    if (!lastmod) {
      lastmod = document.createElement('meta');
      lastmod.setAttribute('name', 'last-modified');
      document.head.appendChild(lastmod);
    }
    lastmod.setAttribute('content', new Date().toISOString().split('T')[0]);

    return () => {
      document.title = '전립상회 PAC KOREA | 프리미엄 건강식품 전문 브랜드';
    };
  }, [product, siteUrl]);

  return null;
};

export default ProductSeo;
